export default "__VITE_ASSET__C9O3n7WF__"